// Feature translation mapping
const featureTranslations = {
  en: {
    'QR ordering': 'QR ordering',
    'Manual orders': 'Manual orders',
    'Themes': 'Themes',
    'Tables': 'Tables',
    'Staff members': 'Staff members',
    'Thermal printing': 'Thermal printing',
    'Multi-language': 'Multi-language',
    'Email support': 'Email support',
    'Priority email support': 'Priority email support',
    'Custom branding': 'Custom branding',
    'SLA support': 'SLA support',
    'Advanced analytics': 'Advanced analytics'
  },
  fr: {
    'QR ordering': 'Commandes QR',
    'Manual orders': 'Commandes manuelles',
    'Themes': 'Thèmes',
    'Tables': 'Tables',
    'Staff members': 'Membres du personnel',
    'Thermal printing': 'Impression thermique',
    'Multi-language': 'Multi-langue',
    'Email support': 'Support par e-mail',
    'Priority email support': 'Support prioritaire par e-mail',
    'Custom branding': 'Image de marque personnalisée',
    'SLA support': 'Support SLA',
    'Advanced analytics': 'Analyses avancées'
  },
  es: {
    'QR ordering': 'Pedidos QR',
    'Manual orders': 'Pedidos manuales',
    'Themes': 'Temas',
    'Tables': 'Mesas',
    'Staff members': 'Miembros del personal',
    'Thermal printing': 'Impresión térmica',
    'Multi-language': 'Multi-idioma',
    'Email support': 'Soporte por correo',
    'Priority email support': 'Soporte prioritario por correo',
    'Custom branding': 'Marca personalizada',
    'SLA support': 'Soporte SLA',
    'Advanced analytics': 'Análisis avanzados'
  },
  ar: {
    'QR ordering': 'طلبات رمز الاستجابة السريعة',
    'Manual orders': 'الطلبات اليدوية',
    'Themes': 'القوالب',
    'Tables': 'الطاولات',
    'Staff members': 'أعضاء الفريق',
    'Thermal printing': 'الطباعة الحرارية',
    'Multi-language': 'متعدد اللغات',
    'Email support': 'الدعم عبر البريد الإلكتروني',
    'Priority email support': 'الدعم المميز عبر البريد الإلكتروني',
    'Custom branding': 'العلامة التجارية المخصصة',
    'SLA support': 'دعم اتفاقية مستوى الخدمة',
    'Advanced analytics': 'التحليلات المتقدمة'
  }
};

export const translateFeature = (featureName, language = 'en') => {
  return featureTranslations[language]?.[featureName] || featureName;
};

export const translateFeatures = (featuresArray, language = 'en') => {
  if (!featuresArray || !Array.isArray(featuresArray)) return [];
  return featuresArray.map(feature => translateFeature(feature, language));
};

export default featureTranslations;
